
import React, { useEffect, useState } from 'react';
import { Row, Col, Table, Spin, Form, Select, Input, DatePicker, Tooltip, Radio, Checkbox, Button, Space, Popconfirm } from 'antd';
import Header from "../../components/Header"
import Footer from '../../components/Footer';
import api from '../../services/api';
import './styles.css';
import { message } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import 'antd/dist/antd.css';
import ModalNovoFeriado from './ModalNovoFeriado/index'
import ModalEditarFeriado from './ModalEditarFeriado/index'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as ModalStatusAction from '../../redux/actions/modalStatus'
import * as PermissaoAction from '../../redux/actions/permissao';
import modalStatus from '../../redux/reducers/permissao';
import Permissao from '../Permissao';
import MaskedInput from 'react-input-mask';
import moment from 'moment';

interface FeriadoProps {
    permissao?: any
    modalStatus?: any,
    setNovoFeriadoModal?: any,
    setEditarFeriadoModal?: any
}

const Feriado: React.FC<FeriadoProps> = (prop) => {

    let visible = prop.modalStatus[0].visibleNovoFeriado
    let feriado: any;
    let feriados: any[] = [];

    const [form] = Form.useForm();
    const [feriadoResponse, setFeriadoResponse] = useState<any[]>();
    const [loading, setLoading] = useState(false);
    const { Option } = Select;
    let tipoFeriados: any[] = [];
    const [tipoFeriadoInput, setTipoFeriadoInput] = useState<any[]>();


    useEffect(() => {
        api.get(`Feriado/gettipoferiado`).then((response) => {
            tipoFeriados = response.data;
            setTipoFeriadoInput(tipoFeriados)
        })
        getFeriados();
    }, [prop.modalStatus[0]])

    const getFeriados = async () => {
        api.get(`Feriado`).then((response) => {
            response.data.forEach((e: any) => {
                let data: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(e.dataInicio))
                feriado = {
                    key: e.feriadoID,
                    dataInicio: data,
                    feriadoID: e.feriadoID,
                    nome: e.nome,
                    descricao: e.descricao,
                    tipo: e.tipo,
                    fixo: e.fixo === true ? 'Sim' : 'Não',
                    ativo: e.ativo === true ? 'Sim' : 'Não',
                    data: e.dataInicio,
                    municipioID: e.municipioID,
                    municipio: e.municipio
                }
                feriados.push(feriado);
            });
            setFeriadoResponse(feriados);
        })
    }

    function toISOFormat(dateTimeString: string) {
        // Primeiro, dividimos a data completa em duas partes:
        const [DD, MM, YYYY] = dateTimeString.split('/');
        // Retornamos a data formatada em um padrão compatível com ISO:
        return `${YYYY}-${MM}-${DD}`;
    }

    const validarData = (_: any, value: { number: number }) => {
        if (form.getFieldValue("dataInicio") != undefined) {
            let result, data;
            let dataFormatada = toISOFormat(form.getFieldValue("dataInicio"));
            data = new Date(dataFormatada);
            result = moment(data).isValid();
            if (result == false) {
                return Promise.reject(new Error('Data inválida!'));
            }
            return Promise.resolve();
        }
        return Promise.resolve();
    };

    const Buscar = async (values: any) => {
        let dataInicio;

        if (values.dataInicio != undefined) {
            let dataFormatada = toISOFormat(values.dataInicio);
            dataInicio = new Date(dataFormatada);
        }
        await api.post(`Feriado/getferiadofiltro`, {
            FeriadoID: 0,
            Nome: values.nome,
            DataInicio: dataInicio,
            Descricao: values.descricao,
            Tipo: values.tipo,
            Fixo: values.fixo === "" ? null : values.fixo === "true" ? true : false,
            Ativo: values.ativo === "" ? null : values.ativo === "true" ? true : false,
        })
            .then((response: any) => {
                if (response.status === 200) {
                    response.data.forEach((e: any) => {
                        let data: any = new Intl.DateTimeFormat('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(new Date(e.dataInicio))
                        feriado = {
                            key: e.feriadoID,
                            dataInicio: data,
                            feriadoID: e.feriadoID,
                            nome: e.nome,
                            descricao: e.descricao,
                            tipo: e.tipo,
                            fixo: e.fixo === true ? 'Sim' : 'Não',
                            ativo: e.ativo === true ? 'Sim' : 'Não',
                            data: e.dataInicio,
                            municipio: e.municipio
                        }
                        feriados.push(feriado);
                    });
                    setFeriadoResponse(feriados);
                    setLoading(false);
                }
            })
            .catch((err) => {
                message.error('Falha na requisição')
                setLoading(false);
            });

        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 50);
    };

    const novoFeriado = async (values: any) => {
        prop.setNovoFeriadoModal(true);
    }

    const editarFeriado = (values: any) => {
        prop.setEditarFeriadoModal(true, values)
    }

    const ativarDesativarFeriado = (feriado: any, ehAtivo: boolean) => {
        setLoading(true);
        api.put(`Feriado`, {
            FeriadoID: feriado.feriadoID,
            Nome: feriado.nome,
            DataInicio: feriado.data,
            Descricao: feriado.descricao,
            Tipo: feriado.tipo,
            Fixo: feriado.fixo === "Sim" ? true : false,
            MunicipioID: feriado.municipioID,
            Ativo: ehAtivo,
        }
        ).then(response => {
            if (response.data.valido) {
                message.success('Feriado alterado com sucesso!');
                prop.setEditarFeriadoModal(false)
                setLoading(false);
            }
            else {
                message.error(response.data.error,10)               
            }            
        }).catch(() => {
            message.error('Falha na requisição');
        }).finally(() => {
            getFeriados();
            setLoading(false);
        })
    }

    const columns: ColumnsType<any> = [
        {
            title: 'Nome',
            dataIndex: 'nome',
        },
        {
            title: 'Data',
            dataIndex: 'dataInicio',
        },
        {
            title: 'Descrição',
            dataIndex: 'descricao',
            ellipsis: {
                showTitle: false,
            },
            render: descricao => (
                <Tooltip placement="topLeft" title={descricao}>
                    {descricao}
                </Tooltip>
            ),
        },
        {
            title: 'Tipo',
            dataIndex: 'tipo',
        },
        {
            title: 'Fixo',
            dataIndex: 'fixo',
            width: 100,
        },
        {
            title: 'Ativo',
            dataIndex: 'ativo',
            width: 100
        },
        {
            title: 'Município',
            render:(text,record:any) =>(
                <>
                {record.municipio != null ? 
                    <span style={{fontWeight:"normal"}}>{record.municipio.nome}</span>
                : <span> </span>
                }
                </>
            ),
        },
        {
            title: 'Ações',
            key: 'action',
            render: (text, record: any) => (
                <Space className='feriadoAcoes' size="middle">
                    {prop.permissao[0].permissaoAcesso?.editar === true ?
                        <Button htmlType="button" onClick={() => editarFeriado(record)}>Editar</Button>
                        : null}
                    {
                        record.ativo == "Sim" ?
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.feriadoID} placement="top" title="Você tem certeza que deseja desativar esse feriado?" onConfirm={() => { ativarDesativarFeriado(record, false); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.feriadoID} danger >  Desativar </Button>
                                </Popconfirm>
                                : null
                            :
                            prop.permissao[0].permissaoAcesso?.editar === true ?
                                <Popconfirm key={record.feriadoID} placement="top" title="Você tem certeza que deseja ativar esse feriado?" onConfirm={() => { ativarDesativarFeriado(record, true); }} okText="Sim" cancelText="Não">
                                    <Button type="primary" key={record.feriadoID}  >  Ativar </Button>
                                </Popconfirm>
                                : null
                    }

                </Space>
            ),
            fixed: 'right' as 'right',
            width: 200
        }
    ];


    return (
        <div>
            <Header></Header>
            <br />
            <div className="container">
                <fieldset className="fieldset-consulta">
                    <Spin spinning={loading}>
                        <Form onFinish={Buscar}
                            labelCol={{ span: 24 }} wrapperCol={{ span: 24 }}
                            layout="horizontal"
                            size="middle"
                            form={form}
                        >
                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Nome"
                                        name="nome"
                                    >
                                        <Input placeholder="Informe o nome do Feriado" />
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={12}>
                                    <Form.Item
                                        label="Descrição"
                                        name="descricao"
                                    >
                                        <Input placeholder="Informe a descrição do Feriado" />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Data"
                                        name="dataInicio"
                                        rules={[
                                            {
                                                validator: validarData
                                            }
                                        ]}
                                    >
                                        <MaskedInput className="ant-input" placeholder="Informe a Data" mask="99/99/9999" />
                                        {/* <DatePicker placeholder="Selecione a Data" style={{ width: '100%' }} format="DD/MM/YYYY" /> */}
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Tipo"
                                        name="tipo"
                                    >
                                        <Select placeholder="Tipo">
                                            {tipoFeriadoInput?.map(tipo => (
                                                <Option value={tipo.enum}>{tipo.enum}</Option>
                                            ))}
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Fixo"
                                        name="fixo"
                                        initialValue=""
                                    >
                                        <Select placeholder="Fixo">
                                            <Option value="">Selecione</Option>
                                            <Option value="true">Sim</Option>
                                            <Option value="false">Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col className="gutter-row" span={6}>
                                    <Form.Item
                                        label="Ativo"
                                        name="ativo"
                                        initialValue=""
                                    >
                                        <Select placeholder="Ativo">
                                            <Option value="">Selecione</Option>
                                            <Option value="true">Sim</Option>
                                            <Option value="false">Não</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Form.Item className="buttons">
                                {prop.permissao[0].permissaoAcesso?.cadastrar === true ?
                                    <Button className="button-novo" onClick={novoFeriado} type="ghost" htmlType="button">
                                        Novo Feriado
                                    </Button>
                                    : null}
                                <Button className="button-filtrar" type="primary" htmlType="submit">
                                    Filtrar
                                </Button>
                            </Form.Item>
                        </Form>
                    </Spin>
                </fieldset>
                <br />
                <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    <Col className="gutter-row" span={24}>
                        <Table loading={loading} columns={columns} dataSource={feriadoResponse} rowKey={"feriadoID"} bordered={true}></Table>
                    </Col>
                </Row>
            </div>
            <Footer></Footer>
            <ModalNovoFeriado></ModalNovoFeriado>
            <ModalEditarFeriado></ModalEditarFeriado>
        </div>

    );
}
const mapStateToProps = (state: any) => ({
    modalStatus: state.modalStatus,
    permissao: state.permissao
})

const mapDispatcToProps = (dispatch: any) => {
    return bindActionCreators(Object.assign({}, PermissaoAction, ModalStatusAction), dispatch);
}

export default connect(mapStateToProps, mapDispatcToProps)(Feriado);